import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  naslov: string;
  opis?: string;
  children?: React.ReactNode;
  noga?: React.ReactNode;
  sirina?: string;
}
export function Modal({
  open,
  onClose,
  naslov,
  opis,
  children,
  noga,
  sirina = 'max-w-lg'
}: ModalProps) {
  return <AnimatePresence data-id="element-448" data-mp="9d3vnr4hqci4">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-6" data-id="element-449" data-mp="9c2kznrdzs0x">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-0 bg-ink/30" onClick={onClose} data-id="element-450" data-mp="4flvap4jh5lq" />
          <motion.div role="dialog" aria-modal="true" aria-label={naslov} initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className={`relative w-full ${sirina} rounded-t-2xl border border-line bg-white shadow-pop sm:rounded-xl`} data-id="element-451" data-mp="2k683xedj0f4v">
            <div className="flex items-start justify-between gap-4 border-b border-line px-5 py-4" data-id="element-452" data-mp="2d434b2mgglat">
              <div data-id="element-453" data-mp="1zcy33w3fvkyd">
                <h2 className="text-[15px] font-semibold text-ink" data-id="element-454" data-mp="1zcfyoc6mi0fd">{naslov}</h2>
                {opis && <p className="mt-0.5 text-sm text-ink-muted" data-id="element-455" data-mp="244zms32xsdyf">{opis}</p>}
              </div>
              <button onClick={onClose} aria-label="Zapri" className="rounded-md p-1 text-ink-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink" data-id="element-456" data-mp="1pftfrsxuxjfz">
                <XIcon className="h-4 w-4" data-id="element-457" data-mp="1gf5b3oucsvfr" />
              </button>
            </div>
            {children && <div className="max-h-[60vh] overflow-y-auto viva-scroll px-5 py-4" data-id="element-458" data-mp="1kf5p58djj4ma">{children}</div>}
            {noga && <div className="flex justify-end gap-2 border-t border-line px-5 py-3" data-id="element-459" data-mp="3n3x9dvyw9xb3">{noga}</div>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}